import { makeVar } from '@apollo/client';

export const hierarchyInEditRootIdVar = makeVar(null);

export const selectedDistrictIdsVar = makeVar([]);

export const selectedCityIdsVar = makeVar([]);

export const shouldRefetchListVar = makeVar(false)

export const isDistrictDirtyVar = makeVar(false)